class LayoutLabelActivator {
    constructor() {
        this._layout = null;
        this._enabled = new Set();
        this._labelSize = new Map();
    }

    setLayout(layout) {
        if (this._layout === layout) {
            return;
        }

        if (this._layout !== null) {
            for (let id of this._enabled) {
                this._layout.removeLabel(id);
            }
        }

        this._layout = layout;

        if (layout !== null) {
            for (let id of this._enabled) {
                layout.addLabel(id);

                if (this._labelSize.has(id)) {
                    const size = this._labelSize.get(id);
                    layout.setLabel(id, { size });
                }
            }
        }
    }

    enableLabel(id, enable) {
        if (this._enabled.has(id) === enable) {
            return;
        }

        if (enable) {
            this._enabled.add(id);

            if (this._layout !== null) {
                this._layout.addLabel(id);

                if (this._labelSize.has(id)) {
                    const size = this._labelSize.get(id);
                    this._layout.setLabel(id, { size });
                }
            }
        } else {
            if (this._layout !== null) {
                this._layout.removeLabel(id);
            }

            this._enabled.delete(id);
            this._labelSize.delete(id);
        }
    }

    setLabelSize(id, size) {
        if (!this._enabled.has(id)) {
            return;
        }

        if (size) {
            const { width, height } = size;
            size = { width, height };
            this._labelSize.set(id, size);

            if (this._layout !== null) {
                this._layout.setLabel(id, { size });
            }
        } else {
            this._labelSize.delete(id);

            if (this._layout !== null) {
                this._layout.setLabel(id, { size: null });
            }
        }
    }
}

export default LayoutLabelActivator;
